/* eslint-disable
    @typescript-eslint/no-explicit-any
*/
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import React from 'react';

import EnzymeActivityTable from './EnzymeActivityTable';
import EnzymeProviderSelector from './EnzymeProviderSelector';

export interface EnzymeActivityTableWithProviderSelectorProps {
  enzymes?: any;
  provider: any;
  onChangeProvider: (...args: Array<any>) => any;
  providers?: any;
  small: boolean;
  pullSelectorRight?: boolean;
}

export default function EnzymeActivityTableWithProviderSelector({
  enzymes,
  onChangeProvider,
  provider,
  providers,
  pullSelectorRight = false,
  small,
}: EnzymeActivityTableWithProviderSelectorProps): JSX.Element {
  return (
    <div className="u-tiny-spacing-top u-small-text">
      <div className={classNames({'pull-right': pullSelectorRight})}>
        <EnzymeProviderSelector
          providers={providers}
          value={provider}
          onChange={onChangeProvider}
          small={small}
          inline={true}
        />
      </div>
      <EnzymeActivityTable enzymes={enzymes} provider={provider} small={small} />
    </div>
  );
}
